(function () {
  var FREE_SHIPPING_THRESHOLDS = {
    GBP: 3500,
    USD: 4500,
    CAD: 6000,
    AUD: 6500,
    BGN: 8000,
    CZK: 100000,
    DKK: 30000,
    HUF: 1600000,
    PLN: 17500,
    RON: 20000,
    SEK: 45000,
    EUR: 4000
  };
  var renderTimer = null;

  function shopifyRoute(path) {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root
      ? Shopify.routes.root
      : '/';
    return root + path.replace(/^\//, '');
  }

function getCustomerLocale() {
    var config = window.axiLocalization || {};
    var country = String(config.country || '').toUpperCase();

    var countryLocales = {
      SI: 'sl-SI',
      DE: 'de-DE',
      AT: 'de-AT',
      FR: 'fr-FR',
      IT: 'it-IT',
      ES: 'es-ES',
      PT: 'pt-PT',
      NL: 'nl-NL',
      BE: 'nl-BE',
      LU: 'fr-LU',
      IE: 'en-IE',
      FI: 'fi-FI',
      EE: 'et-EE',
      LV: 'lv-LV',
      LT: 'lt-LT',
      GR: 'el-GR',
      HR: 'hr-HR',
      SK: 'sk-SK',
      CY: 'el-CY',
      MT: 'mt-MT',
      BG: 'bg-BG',
      CZ: 'cs-CZ',
      DK: 'da-DK',
      HU: 'hu-HU',
      PL: 'pl-PL',
      RO: 'ro-RO',
      SE: 'sv-SE',
      GB: 'en-GB',
      US: 'en-US',
      CA: 'en-CA',
      AU: 'en-AU'
    };

    if (countryLocales[country]) {
      return countryLocales[country];
    }

    return (
      config.language ||
      document.documentElement.lang ||
      navigator.language ||
      'en'
    );
  }

  function formatMoney(cents, currencyCode) {
    var config = window.axiLocalization || {};
    var currency = currencyCode || config.currency || 'EUR';

    try {
      return new Intl.NumberFormat(getCustomerLocale(), {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return (
        ((Number(cents) || 0) / 100).toFixed(2) +
        ' ' +
        currency
      );
    }
  }

  function getDrawer() {
    return document.querySelector('cart-drawer-component');
  }

  function getShippingThreshold(currencyCode) {
    return FREE_SHIPPING_THRESHOLDS[currencyCode] || FREE_SHIPPING_THRESHOLDS.EUR;
  }

  function ensureProgressBar() {
    var drawer = getDrawer();
    if (!drawer) return null;

    var existing = drawer.querySelector('.axi-shipping-progress');
    if (existing) return existing;

    var header = drawer.querySelector('.cart-drawer__header');
    if (!header) return null;

    var progress = document.createElement('div');
    progress.className = 'axi-shipping-progress';
    progress.setAttribute('role', 'status');
    progress.setAttribute('aria-live', 'polite');
    progress.innerHTML =
  '<p class="axi-shipping-progress__message"></p>' +
  '<div class="axi-shipping-progress__row">' +
    '<div class="axi-shipping-progress__track" aria-hidden="true">' +
      '<span class="axi-shipping-progress__fill"></span>' +
    '</div>' +
    '<span class="axi-shipping-progress__free">FREE</span>' +
  '</div>';

    header.insertAdjacentElement('afterend', progress);
    return progress;
  }

  function updateProgress(cart) {
    var progress = ensureProgressBar();
    if (!progress) return;

    var threshold = getShippingThreshold(cart.currency);
    var subtotal = Number(cart.total_price) || 0;
    var remaining = Math.max(threshold - subtotal, 0);
    var percentage = Math.min((subtotal / threshold) * 100, 100);
    var message = remaining > 0
  ? 'Add <span class="axi-shipping-progress__amount">' +
    formatMoney(remaining, cart.currency) +
    '</span> more for free shipping.'
  : 'You qualify for free shipping!';

    var messageNode = progress.querySelector('.axi-shipping-progress__message');
    var fillNode = progress.querySelector('.axi-shipping-progress__fill');

    if (messageNode.innerHTML !== message) {
  messageNode.innerHTML = message;
}
    fillNode.style.width = percentage + '%';
    progress.classList.toggle('is-complete', remaining === 0);
  }

  function renderProgress() {
    fetch(shopifyRoute('cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to load cart');
        return response.json();
      })
      .then(updateProgress)
      .catch(function () {});
  }

  function scheduleRender(delay) {
    clearTimeout(renderTimer);
    renderTimer = setTimeout(renderProgress, delay || 0);
  }

  function watchDrawer() {
    var drawer = getDrawer();
    if (!drawer) {
      setTimeout(watchDrawer, 500);
      return;
    }

    ensureProgressBar();
    renderProgress();

    new MutationObserver(function (mutations) {
      var shouldRender = mutations.some(function (mutation) {
        var element = mutation.target.nodeType === 1
          ? mutation.target
          : mutation.target.parentElement;
        return !element || !element.closest('.axi-shipping-progress');
      });
      if (shouldRender) scheduleRender(150);
    }).observe(drawer, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('cart:update', function () {
    scheduleRender(250);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawer);
  } else {
    watchDrawer();
  }
})();